<div class="column">
  <nz-tabset class="u-padding-16">
    @if (displayActionData.length) {
      <nz-tab [nzTitle]="actionTabTitle">
        <div fxLayout="column">
          <div class="u-margin-16">
            <p [innerHTML]="description"></p>
            <p>
              {{ subtitle }}
            </p>
          </div>
          <div
            class="u-margin-16"
            fxFlex="75%"
            fxLayout="column"
            fxLayout.gt-xs="row"
            fxLayoutAlign.gt-xs="start center"
            fxLayoutGap="8px"
          >
            <app-program-participants-filter
              [searchQuery]="route.snapshot.queryParamMap.get('query')"
              (filterValueChange)="onSearchInputChange($event)"
              class="u-display-block u-width-100"
            ></app-program-participants-filter>
          </div>
          <div class="u-margin-0-16" fxLayout="row">
            <div i18n="@@actionItemDrawer.membersCount">
              {{ memberCount }} members selected
            </div>
            <div fxFlex="auto" fxLayoutAlign="end center">
              @if (actionQueueToDelete === actionQueueType) {
                <button [matMenuTriggerFor]="deleteMenu" mat-stroked-button>
                  <span
                    fxLayout="row"
                    fxLayoutAlign="end center"
                    fxLayoutGap="4px"
                  >
                    <span class="c-button color-blue" i18n="@@global.actions"
                      >Actions</span
                    >
                    <mat-icon class="color-blue">keyboard_arrow_down</mat-icon>
                  </span>
                </button>
              }
              <mat-menu #deleteMenu>
                <button
                  (click)="selectAllAction('remove-account-from-group')"
                  mat-menu-item
                  i18n="@@actionItemDrawer.actionsMenu.deleteAll"
                >
                  Remove all from {{ group.name }}
                </button>
                <button
                  (click)="selectAllAction('delete-account')"
                  mat-menu-item
                  i18n="@@actionItemDrawer.actionsMenu.deleteFromTenantAll"
                >
                  Delete all accounts permanently
                </button>
              </mat-menu>
            </div>
          </div>
          <nz-table
            #actionItemDataTable
            [nzData]="displayActionData"
            [nzPageIndex]="pageIndex"
            [nzPageSize]="pageSize"
            [nzScroll]="{
              x: [actionQueueToDelete, actionQueueToDeactivate].includes(
                actionQueueType
              )
                ? '90%'
                : columnWidth,
              y: '475px',
            }"
            [nzShowPagination]="actionItems.length > pageSize"
            (nzPageIndexChange)="pageIndex = $event"
            class="u-padding-16"
            nzOuterBordered
            nzSize="small"
            nzTableLayout="fixed"
          >
            <thead>
              <tr>
                <th
                  [nzChecked]="areAllSelected(pageIndex)"
                  [nzIndeterminate]="isIndeterminate(pageIndex)"
                  (nzCheckedChange)="selectAll(pageIndex)"
                  nzWidth="60px"
                ></th>
                @if (!useFullName) {
                  <th
                    [nzSortFn]="'first_name' | appMakeSortStringFn"
                    nzSortOrder="ascend"
                    i18n="@@global.firstName"
                  >
                    First name
                  </th>
                  <th
                    [nzSortFn]="'last_name' | appMakeSortStringFn"
                    nzSortOrder="ascend"
                    i18n="@@global.lastName"
                  >
                    Last name
                  </th>
                } @else {
                  <th
                    [nzSortFn]="'full_name' | appMakeSortStringFn"
                    nzSortOrder="ascend"
                    i18n="@@global.fullName"
                  >
                    Full name
                  </th>
                }
                <th
                  [nzSortFn]="'email' | appMakeSortStringFn"
                  nzSortOrder="ascend"
                  i18n="@@global.email"
                >
                  Email
                </th>
                @if (
                  [actionQueueToDelete, actionQueueToDeactivate].includes(
                    actionQueueType
                  )
                ) {
                  @if (actionQueueToDelete === actionQueueType) {
                    <th i18n="@@actionItemDrawer.tableHeader.action">Action</th>
                  }
                }
                @for (profileFieldHeader of profileFieldHeaders; track $index) {
                  <th>
                    {{ profileFieldHeader }}
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (data of actionItemDataTable.data; track $index) {
                <tr>
                  <td
                    [nzChecked]="!data.skip"
                    (nzCheckedChange)="setSkipStatus(data._id, $index, $event)"
                    class="u-textAlign-center"
                    nzWidth="60px"
                  ></td>
                  @if (!useFullName) {
                    <td>
                      {{ data.payload_translated.first_name }}
                    </td>
                    <td>
                      {{ data.payload_translated.last_name }}
                    </td>
                  } @else {
                    <td>
                      {{ data.account.full_name }}
                    </td>
                  }
                  <td>
                    {{ data.payload_translated.email }}
                  </td>
                  @if (
                    [actionQueueToDelete, actionQueueToDeactivate].includes(
                      actionQueueType
                    )
                  ) {
                    @if (actionQueueToDelete === actionQueueType) {
                      <td>
                        <nz-select
                          [compareWith]="compareSelectedValues"
                          [disabled]="data.skip"
                          [ngStyle]="{ width: '170px' }"
                          [(ngModel)]="selectionItems[pageIndex - 1][$index]"
                          (ngModelChange)="
                            updateAction(data._id, $index, $event)
                          "
                          nzPlaceHolder="Choose action"
                          i18n-nzPlaceHolder="
                            @@actionItemDrawer.actionTable.placeHolder"
                        >
                          @for (option of selectOptions; track option.value) {
                            <nz-option
                              [nzLabel]="option.label"
                              [nzValue]="option"
                            ></nz-option>
                          }
                        </nz-select>
                      </td>
                    }
                  } @else {
                    @for (
                      profileValue of profileValues[data._id];
                      track $index
                    ) {
                      <td>
                        {{ profileValue }}
                      </td>
                    }
                  }
                </tr>
              }
            </tbody>
          </nz-table>
          <div
            class="u-borderTop-grey100 u-padding-0-24 u-paddingTop-16"
            fxLayout="row"
            fxLayoutAlign="end center"
            fxLayoutGap="8px"
          >
            <button
              (click)="closeDrawer('pending')"
              mat-stroked-button
              i18n="@@global.cancel"
            >
              Cancel
            </button>
            <button
              (click)="openConfirmationDialog()"
              color="primary"
              mat-raised-button
            >
              <span i18n="@@global.submit">Submit</span>
              @if (isLoading) {
                <i
                  class="u-marginLeft-8"
                  nz-icon
                  nzSpin
                  nzTheme="outline"
                  nzType="sync"
                ></i>
              }
            </button>
          </div>
        </div>
      </nz-tab>
    }
    <nz-tab [nzTitle]="completedTabTitle">
      <div fxLayout="column">
        <div class="u-paddingBottom-24" fxFlex="0 0 calc(100vh - 200px)">
          @if (successItems.length) {
            <div
              class="u-display-block u-padding-8 u-margin-0-16 u-margin-8-0 u-border-teal700 u-borderRadius--4px"
            >
              <div fxLayout="row" fxLayoutGap="8px">
                <div fxLayout="column" fxLayoutAlign="start start">
                  <mat-icon
                    class="material-symbols-outlined u-width-100 md-24 color-teal-700"
                    >check_circle</mat-icon
                  >
                </div>
                <div fxLayout="column">
                  <p>{{ successPopUp }}</p>
                </div>
              </div>
            </div>
            <div class="u-margin-16" fxLayout="row">
              <div
                fxLayoutAlign="start center"
                i18n="@@actionItemDrawer.completedCount"
              >
                {{ completedItemsCount }} members
              </div>
            </div>
            <nz-table
              #successTable
              [nzData]="successItems"
              [nzPageSize]="pageSize"
              [nzScroll]="{
                x: [actionQueueToDelete, actionQueueToDeactivate].includes(
                  actionQueueType
                )
                  ? '90%'
                  : columnWidth,
                y: '475px',
              }"
              [nzShowPagination]="successItems.length > pageSize"
              class="u-padding-16"
              nzOuterBordered
              nzSize="middle"
            >
              <thead>
                <tr>
                  @if (!useFullName) {
                    <th
                      [nzSortFn]="'first_name' | appMakeSortStringFn"
                      i18n="@@global.firstName"
                    >
                      First name
                    </th>
                    <th
                      [nzSortFn]="'last_name' | appMakeSortStringFn"
                      i18n="@@global.lastName"
                    >
                      Last name
                    </th>
                  } @else {
                    <th
                      [nzSortFn]="'full_name' | appMakeSortStringFn"
                      i18n="@@global.fullName"
                    >
                      Full name
                    </th>
                  }
                  <th
                    [nzSortFn]="'email' | appMakeSortStringFn"
                    i18n="@@global.email"
                  >
                    Email
                  </th>
                  @for (
                    profileField of profileFieldHeaders;
                    track profileField
                  ) {
                    <th>
                      {{ profileField }}
                    </th>
                  }
                  @switch (actionQueueType) {
                    @case (actionQueueToDeactivate) {
                      <th
                        nzRight
                        i18n="
                          @@actionItemDrawer.successTableHeader.deactivatedOn"
                      >
                        Deactivated on
                      </th>
                    }
                    @case (actionQueueToDelete) {
                      <th
                        nzRight
                        i18n="@@actionItemDrawer.successTableHeader.deletedOn"
                      >
                        Deleted on
                      </th>
                    }
                    @case (actionQueueToInvite) {
                      <th
                        nzRight
                        i18n="@@actionItemDrawer.successTableHeader.invitedOn"
                      >
                        Invited on
                      </th>
                    }
                    @case (actionQueueToUpdate) {
                      <th
                        nzRight
                        i18n="@@actionItemDrawer.successTableHeader.updatedOn"
                      >
                        Updated on
                      </th>
                    }
                  }
                </tr>
              </thead>
              <tbody>
                @for (data of successTable.data; track $index) {
                  <tr>
                    @if (!useFullName) {
                      <td>
                        {{ data.payload_translated.first_name }}
                      </td>
                      <td>
                        {{ data.payload_translated.last_name }}
                      </td>
                    } @else {
                      <td>
                        {{ data.account?.full_name }}
                      </td>
                    }
                    <td>{{ data.payload_translated.email }}</td>
                    @if (
                      [actionQueueToUpdate, actionQueueToInvite].includes(
                        actionQueueType
                      )
                    ) {
                      @for (
                        profileValue of successValues[data._id];
                        track $index
                      ) {
                        <td>
                          {{ profileValue }}
                        </td>
                      }
                    }
                    <td nzRight>
                      {{ data.updated_at | date: 'longDate' }}
                    </td>
                  </tr>
                }
              </tbody>
            </nz-table>
          } @else {
            <div
              class="u-verticalAlign-middle u-padding-16-0"
              fxLayout="column"
              fxLayoutAlign="start center"
            >
              <img
                [ngStyle]="{ 'max-width': '125px' }"
                alt=""
                src="//storage.googleapis.com/ttc-static-images/Empty%20State%20Illustrations/No%20User.0B48472.png"
              />
              <div class="u-textAlign-center u-marginTop-16">
                {{ noMembers }}
              </div>
            </div>
          }
        </div>
        <div
          class="u-borderTop-grey100 u-padding-0-24 u-paddingTop-16"
          fxLayout="row"
          fxLayoutAlign="end center"
          fxLayoutGap="8px"
        >
          <button
            (click)="closeDrawer(actionQueueStatus)"
            color="primary"
            mat-raised-button
            i18n="@@global.done"
          >
            Done
          </button>
        </div>
      </div>
    </nz-tab>
    @if (errorItemData.length) {
      <nz-tab nzTitle="Invalid" i18n-nzTitle="@@actionItemDrawer.invalid">
        <div
          class="bg-color-white u-display-block u-padding-16 u-margin-16 u-border-grey100 u-borderRadius--4px"
        >
          <div fxLayout="row" fxLayoutGap="8px">
            <div fxLayout="column" fxLayoutAlign="start start">
              <mat-icon class="color-orange material-symbols-outlined"
                >error</mat-icon
              >
            </div>
            <ng-template #deletedErrorItems>
              <span [ngPlural]="errorItemData.length">
                <ng-template ngPluralCase="=1">
                  <b i18n="@@actionItemDrawer.alert.deletedSingleBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profile could not be deleted.
                  </b>
                </ng-template>
                <ng-template ngPluralCase="other">
                  <b i18n="@@actionItemDrawer.alert.deletePluralBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profiles could not be deleted.
                  </b>
                </ng-template>
              </span>
            </ng-template>
            <ng-template #deactivatedErrorItems>
              <span [ngPlural]="errorItemData.length">
                <ng-template ngPluralCase="=1">
                  <b i18n="@@actionItemDrawer.alert.deactiveSingleBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profile could not be deactivated.
                  </b>
                </ng-template>
                <ng-template ngPluralCase="other">
                  <b i18n="@@actionItemDrawer.alert.deactivatePluralBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profiles could not be deactivated.
                  </b>
                </ng-template>
              </span>
            </ng-template>
            <ng-template #invitedErrorItems>
              <span [ngPlural]="errorItemData.length">
                <ng-template ngPluralCase="=1">
                  <b i18n="@@actionItemDrawer.alert.inviteSingleBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profile could not be invited.
                  </b>
                </ng-template>
                <ng-template ngPluralCase="other">
                  <b i18n="@@actionItemDrawer.alert.invitePluralBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profiles could not be invited.
                  </b>
                </ng-template>
              </span>
            </ng-template>
            <ng-template #updatedErrorItems>
              <span [ngPlural]="errorItemData.length">
                <ng-template ngPluralCase="=1">
                  <b i18n="@@actionItemDrawer.alert.updateSingleBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    profile could not be updated.
                  </b>
                </ng-template>
                <ng-template ngPluralCase="other">
                  <b i18n="@@actionItemDrawer.alert.updatePluralBody">
                    {{ errorItemCount }}/{{
                      memberCount + completedItemsCount + errorItemCount
                    }}
                    member profiles could not be updated.
                  </b>
                </ng-template>
              </span>
            </ng-template>
            <div fxLayout="column">
              @switch (actionQueueType) {
                @case (actionQueueToDeactivate) {
                  <ng-container
                    *ngTemplateOutlet="deactivatedErrorItems"
                  ></ng-container>
                }
                @case (actionQueueToDelete) {
                  <ng-container
                    *ngTemplateOutlet="deletedErrorItems"
                  ></ng-container>
                }
                @case (actionQueueToInvite) {
                  <ng-container
                    *ngTemplateOutlet="invitedErrorItems"
                  ></ng-container>
                }
                @case (actionQueueToUpdate) {
                  <ng-container
                    *ngTemplateOutlet="updatedErrorItems"
                  ></ng-container>
                }
              }
              <p i18n="@@actionItemDrawer.alert.subBody">
                <a
                  class="color-blue"
                  href="https://support.tenthousandcoffees.com/hc"
                  target="_blank"
                  >Contact 10KC</a
                >
                for more information on this error
              </p>
            </div>
          </div>
        </div>
        <div fxLayout="column">
          <div class="u-paddingBottom-24" fxFlex="0 0 calc(100vh - 310px)">
            <div class="u-margin-0-16" fxLayout="row">
              <div
                fxLayoutAlign="start center"
                i18n="@@actionItemDrawer.errorCount"
              >
                {{ errorItemCount }} members
              </div>
            </div>
            <nz-table
              #errorTable
              [nzData]="errorItemData"
              [nzPageSize]="pageSize"
              [nzScroll]="{
                x: [actionQueueToDeactivate, actionQueueToDelete].includes(
                  actionQueueType
                )
                  ? '90%'
                  : columnWidth,
                y: '475px',
              }"
              [nzShowPagination]="errorItemData.length > pageSize"
              class="u-padding-16"
              nzOuterBordered
              nzSize="middle"
            >
              <thead>
                <tr>
                  @if (!useFullName) {
                    <th i18n="@@global.firstName">First name</th>
                    <th i18n="@@global.lastName">Last name</th>
                  } @else {
                    <th i18n="@@global.fullName">Full name</th>
                  }
                  <th i18n="@@global.email">Email</th>
                  @if (
                    [actionQueueToDelete, actionQueueToDeactivate].includes(
                      actionQueueType
                    )
                  ) {
                    <th i18n="@@global.status">Status</th>
                  }
                  @for (
                    profileFieldHeader of profileFieldHeaders;
                    track $index
                  ) {
                    <th>
                      {{ profileFieldHeader }}
                    </th>
                  }

                  <th nzRight i18n="@@global.error">Error</th>
                </tr>
              </thead>
              <tbody>
                @for (data of errorTable.data; track data._id) {
                  <tr>
                    @if (!useFullName) {
                      <td>
                        {{ data.payload_translated.first_name }}
                      </td>
                      <td>
                        {{ data.payload_translated.last_name }}
                      </td>
                    } @else {
                      <td>
                        {{ data.account?.full_name }}
                      </td>
                    }
                    <td>{{ data.payload_translated.email }}</td>
                    @if (
                      [actionQueueToDelete, actionQueueToDeactivate].includes(
                        actionQueueType
                      )
                    ) {
                      <td>
                        {{ data.action }}
                      </td>
                    } @else {
                      @for (
                        profileValue of errorValues[data._id];
                        track $index
                      ) {
                        <td>
                          {{ profileValue }}
                        </td>
                      }
                    }
                    <td nzRight>
                      {{ data.error_causes[0].message }}
                    </td>
                  </tr>
                }
              </tbody>
            </nz-table>
          </div>
          <div
            class="u-borderTop-grey100 u-padding-0-24 u-paddingTop-16"
            fxLayout="row"
            fxLayoutAlign="end center"
            fxLayoutGap="8px"
          >
            <button
              (click)="closeDrawer(actionQueueStatus)"
              color="primary"
              mat-raised-button
              i18n="@@global.done"
            >
              Done
            </button>
          </div>
        </div>
      </nz-tab>
    }
  </nz-tabset>
</div>
